import { NamespacedImageKeys } from '@betty/moonlight';
import { InboxMessageType } from '../state';

export const inboxMessageIconMap: Record<
  InboxMessageType,
  NamespacedImageKeys
> = {
  DailyGift: 'common.GiftBox',
  Coins: 'common.Coin',
  Level: 'common.LevelUp',
  'Free Spins': 'common.Spins',
  CommunityJackpot: 'common.Jackpot',
  Cash: 'common.Cash',
  LadderProgress: 'common.Megaphone',
  Bonus: 'common.Cash',
  InstantWheel: 'common.Wheel',
};
